import { Theme } from '@material-ui/core'
import {
  fullsizeAbsolute,
  layoutContentMaxWidthPx,
  transition,
} from '../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderStyles = makeStyles((theme: Theme) => ({
  appBarHolder: {
    maxWidth: layoutContentMaxWidthPx,
    margin: `${theme.spacing(0)} auto`,
    padding: theme.spacing(0, 2.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0),
    },
  },
  loaderHolder: {
    ...fullsizeAbsolute,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: transition,
    transformOrigin: 'center',
  },
  loaderHolderLoaded: {
    transform: 'scale(0.2)',
    visibility: 'visible',
    opacity: 0,
  },
  appBar: {
    borderRadius: theme.spacing(5),
    paddingLeft: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      marginTop: theme.spacing(0),
    },
  },
  appBarStagingEnvironment: {
    borderRadius: theme.spacing(5),
    paddingLeft: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      marginTop: theme.spacing(2.5),
    },
  },
  menuWrapper: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    width: '100%',
    transform: `translateY(${theme.spacing(12.5)})`,
    opacity: 0,
    visibility: 'hidden',
    transformOrigin: 'center',
    transition: transition,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  menuWrapperLoaded: {
    transform: 'translateY(0)',
    opacity: 1,
    transformOrigin: 'center',
    visibility: 'visible',
  },
  menuItem: {
    margin: theme.spacing(0, 1.125),
    color: 'black',
    fontSize: theme.typography.pxToRem(14.4),
    fontWeight: 600,
    textDecoration: 'none',
  },
  menuBlockWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  menuBlockLeft: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(1140)]: {
      display: 'none',
    },
  },
  menuBlockRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.palette.grey[500],
    flex: 1,
    [theme.breakpoints.down('md')]: {
      minWidth: 0,
    },
    [theme.breakpoints.down(1140)]: {
      flex: 'initial',
    },
  },

  dropdownMenuIcon: {
    color: theme.palette.text.primary,
    display: 'block',
    lineHeight: 1,
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadius,
    transition: transition,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  dropdownMenu: {
    marginTop: theme.spacing(1),
    minWidth: theme.spacing(27.5),
    '& .MuiPaper-root': {
      borderRadius: theme.shape.borderRadius * 2,
      boxShadow: theme.shadows[8],
      border: `1px solid ${theme.palette.divider}`,
      boxSizing: 'border-box',
      padding: theme.spacing(0.5, 1.5),
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    '& .MuiMenuItem-root': {
      padding: theme.spacing(1.25, 2),
      minHeight: theme.spacing(6),
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 600,
      margin: theme.spacing(0.25, 0),
      borderRadius: theme.shape.borderRadius * 2,
      transition: transition,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        transform: `translateX(${theme.spacing(0.5)})`,
        '& a': {
          color: theme.palette.common.white,
        },
      },
      '&:active': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    '& a': {
      textDecoration: 'none',
      color: theme.palette.text.primary,
      margin: theme.spacing(0),
      minWidth: 0,
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(15),
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      transition: transition,
    },
  },
}))
